<template>
  <div class="position-relative mdc-menu-anchor menu-container pdl-8">
    <button
      class="mdc-button mdc-button--icon-leading js--dropdown-toggle mgr--8"
    >
      <span class="mdc-button__ripple"></span>
      <span class="t-body3 font-r t-color-bodyGrayA pdr-8 d-inline-block t-nowrap letter-0">
        {{ sortHeadline }}
      </span>
      <i class="material-icons t-color-bodyGrayA dropdownIcon">arrow_drop_down</i>
    </button>

    <div
      class="mdc-menu mdc-menu-surface toggle-menu right4"
    >
      <ul
        class="mdc-list"
        role="menu"
        aria-hidden="true"
        aria-orientation="vertical"
        tabindex="-1"
      >
        <li
          class="mdc-list-item  d-flex align-items-center pdt-14 pdb-13 h-48"
          role="menuitem"
          v-for="(sort, index) in sortOptions"
          :key="index + 'sort'"
          @click="searchSort(sort.sortValue)"
        >
          <span class="mdc-list-item__ripple"></span>
          <span
            class="mdc-list-item__text t-body6 font-r t-color-headlineBlack t-line-h-21"
            :class="
              sort.isShow
                ? 't-color-headlineBlack t-nowrap'
                : 't-color-bodyGrayA t-nowrap'
            "
          >
            {{ $t(sort.translateKey) }}
          </span>
        </li>
      </ul>
    </div>
    <div class="toggle-menu-scrim d-none"></div>
  </div>
</template>

<script>
import {MDCMenu} from '@material/menu';
export default {
  name: "RightListSortOptions",
  props: {
    sortOptions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortHeadline() {
      const sort = this.sortOptions.find((sort) => sort.isShow === true);
      return this.$t(sort.translateKey);
    },
    currentArrow() {
      return this.isToggleSide ? "arrow_drop_up" : "arrow_drop_down";
    },
  },
  data() {
    return {
      isToggleSide: false,
    };
  },
  created() {
    document.addEventListener('keyup', function (evt) {
        if (evt.keyCode === 27) {
          document.querySelector('.dropdownIcon').innerHTML = 'arrow_drop_down';
          document.querySelector('.toggle-menu-scrim').classList.add('d-none');
        }
    });
  },
  mounted() {
    this.menuIconToggle();
  },
  methods: {
    menuIconToggle(){
      const menuEls = Array.from(document.querySelectorAll('.mdc-menu'));
      menuEls.forEach((menuEl) => {
        this.menuBar = new MDCMenu(menuEl);
        const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
        const toggleScrimm = menuEl.parentElement.querySelector('.toggle-menu-scrim');

        dropdownToggle.addEventListener('click', () => {
          this.menuActivate(this.menuBar)
        });
        toggleScrimm.addEventListener('click', () => {
          this.menuActivate(this.menuBar)
        });
    });
    },

    menuActivate(menu){
      const toggleBackground = document.querySelector('.toggle-menu-scrim')
      menu.open = !menu.open;
          if(menu.open){
            document.querySelector('.dropdownIcon').innerHTML = 'arrow_drop_up';
            toggleBackground.classList.remove('d-none');
          }else{
            document.querySelector('.dropdownIcon').innerHTML = 'arrow_drop_down';
            toggleBackground.classList.add('d-none')
          }
    },

    searchSort(value) {
      this.$emit("searchSort", value);
      document.querySelector('.dropdownIcon').innerHTML = 'arrow_drop_down';
      document.querySelector('.toggle-menu-scrim').classList.add('d-none');
    },
  },
};
</script>

<style scoped></style>
